import { render, staticRenderFns } from "./detaile.vue?vue&type=template&id=b1838828&scoped=true"
import script from "./detaile.vue?vue&type=script&lang=ts"
export * from "./detaile.vue?vue&type=script&lang=ts"
import style0 from "./detaile.vue?vue&type=style&index=0&id=b1838828&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1838828",
  null
  
)

export default component.exports